export const textsection = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Take a Quiz On',
  headline: 'Test your technical knowledge',
  description: [
    'JAVASCRIPT',
    'HTML',
    'DOCKER',
    'PHP',
    'KUBERNETES',
    'MYSQL',
    'WORDPRESS',
    'LINUX',
    'DEVOPS',
    'BASH',
    'LARAVEL',
  ],
  imgStart: '',
  img: 'images/5.svg',
  alt: 'TechnoQuiz',
};
export const sectionOne = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'TechnoQuiz',
  headline: 'Interactive way to learn',
  description: 'Enhance your skills and expand your knowledge. Get the best of us!',
  setbtnLink : true,
  btnLink : '/signup',
  buttonLabel: 'Sign Up',
  imgStart: 'start',
  img: 'images/1.svg',
  alt: 'TechnoQuiz',
};

export const sectionTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Product',
  headline: 'What is it all about?',
  description:
     'Choose your favourite topics with a variety of questions set for beginners and seniors alike!',
  buttonLabel: 'Try Now',
  setbtnLink : true,
  btnLink : '/category',
  imgStart: '',
  img: 'images/2.svg',
  alt: 'TechnoQuiz',
};
export const sectionThree = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Premium',
  headline: 'Buy our Premium Membership to get an extra edge',
  description: 'Get acccess to all hard questions and explainations',
  setbtnLink : true,
  btnLink : '/premium',
  buttonLabel: 'View Plans',
  imgStart: 'start',
  img: 'images/3.svg',
  alt: 'TechnoQuiz',
};

export const sectionFour = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'TechnoQuiz',
  headline: 'Learning Made Easy',
  description: 'Hone your technical skills',
  buttonLabel: 'Explore Now',
  imgStart: '',
  img: 'images/4.svg',
  alt: 'TechnoQuiz',
};

export const videoSectionOne = {
  headline: 'Test Your Skills',
  description: 'choose your favourite programming language',
  buttonLabel: 'Explore Now',
  vid: 'videos/2.mp4',
};
